import actionsSearch from "./actions";

export default {
  namespaced: true,
  actions: actionsSearch,
};
